// Category browsing never changes the independently selected purchasable set variant.
(() => {
  document.querySelectorAll('[data-home-catalog]').forEach(catalog => {
    const track=catalog.querySelector('[data-catalog-track]');
    const cards=[...catalog.querySelectorAll('[data-catalog-kind]')];
    const filters=[...catalog.querySelectorAll('[data-catalog-filter]')];
    const updateArrows=()=>catalog.querySelectorAll('[data-catalog-step]').forEach(button=>{
      const end=Math.max(0,(track?.scrollWidth||0)-(track?.clientWidth||0));
      button.disabled=Number(button.dataset.catalogStep)<0?(track?.scrollLeft||0)<2:(track?.scrollLeft||0)>=end-2;
    });
    const apply=key=>{
      filters.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.catalogFilter===key)));
      cards.forEach(card=>{card.hidden=key!=='all'&&!card.dataset.catalogKind.split(' ').includes(key);});
      if(track)track.scrollTo({left:0,behavior:'instant'});
      requestAnimationFrame(updateArrows);
      const count=catalog.querySelector('[data-catalog-count]');
      if(count)count.textContent=String(cards.filter(card=>!card.hidden).length);
    };
    filters.forEach(button=>button.addEventListener('click',()=>apply(button.dataset.catalogFilter)));
    catalog.querySelectorAll('[data-catalog-step]').forEach(button=>button.addEventListener('click',()=>{
      const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
      track?.scrollBy({left:Math.sign(Number(button.dataset.catalogStep))*track.clientWidth*.85,behavior:reduced?'instant':'smooth'});
    }));
    track?.addEventListener('scroll',updateArrows,{passive:true});
    window.addEventListener('resize',updateArrows,{passive:true});
    if(filters.length)apply(filters.find(button=>button.getAttribute('aria-pressed')==='true')?.dataset.catalogFilter||'all');
    // Menu deep links reveal the requested category even after another filter was selected.
    const applyFilterHash=hash=>{
      const button=filters.find(button=>button.id && '#'+button.id===hash);
      if(button)apply(button.dataset.catalogFilter);
    };
    applyFilterHash(location.hash);
    window.addEventListener('hashchange',()=>applyFilterHash(location.hash));
    document.addEventListener('click',event=>{
      const link=event.target.closest?.('a[href]');
      if(!link)return;
      const target=new URL(link.href,location.href);
      if(target.origin===location.origin&&target.pathname===location.pathname&&target.search===location.search)applyFilterHash(target.hash);
    });
  });
})();
